export default __webpack_public_path__ + "static/AseoInd_6-0510806f14945a29258b1c6e9867a810.png";